// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-button button {
  width: 215px !important;
  padding: 16px 8px !important;
}

@media screen and (max-width: 650px) {
  .hero-button button {
    width: 350px !important;
    padding: 16px 8px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/landing/section/style.scss"],"names":[],"mappings":"AACE;EACE,uBAAA;EACA,4BAAA;AAAJ;;AAIA;EAEE;IACE,uBAAA;IACA,4BAAA;EAFF;AACF","sourcesContent":[".hero-button{\n  button{\n    width: 215px !important;\n    padding: 16px 8px !important;\n  }\n}\n\n@media screen and (max-width: 650px) {\n.hero-button{\n  button{\n    width: 350px !important;\n    padding: 16px 8px !important;\n  }\n}\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
